import script from "./UserRolesCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRolesCell.vue?vue&type=script&setup=true&lang=ts"

import "./UserRolesCell.vue?vue&type=style&index=0&id=81bb14a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81bb14a0"]])

export default __exports__